import { Stage, Layer, Image } from 'react-konva';
import EditableText from './EditableText';
import EditableImage from './EditableImage';

import { useRef, useState, useEffect } from 'react';

const Canvas = ({stageRef, onTextBoxSelect, currentTextKey, selectedImageKey, onImageSelect, checkDeselect,
                onTextBoxChange, onImageChange, bgImageObject, addTextArea, textAreaVisibility, setTextAreaVisibility, 
                textAreaStyle, currentTextBoxText, setCurrentTextBoxText, orientation, 
                objectState, fontFamily, fontSize, textBoxRotation, textColor}) => {

    let objects = [];
    const bgImageRef = useRef();
    const containerRef = useRef();
    // const stageRef = useRef();

    const BASE_HEIGHT = 420;
    const BASE_WIDTH = 594;

    const [size, setSize] = useState({
        width: window.innerWidth/2,
        height: (window.innerWidth/2)/1.4142
    })

    let scaleX, scaleY;

    if(orientation === "landscape") {
        scaleX = size.width / BASE_WIDTH;
        scaleY = size.height / BASE_HEIGHT;    
    } else {
        scaleY = size.width / BASE_WIDTH;
        scaleX = size.height / BASE_HEIGHT;            
    }

    const [bgSize, setBgSize] = useState({
        width: stageRef?.current?.attrs?.width / scaleX,
        height: stageRef?.current?.attrs?.height / scaleY
    })

    useEffect(() => {
        const checkSize = () => {
            if(orientation === "landscape") {
                setSize({
                    width: window.innerWidth/2,
                    height: (window.innerWidth/2)/1.4142
                })    
                setBgSize({
                    width: stageRef?.current?.attrs?.width / scaleX,
                    height: stageRef?.current?.attrs?.height / scaleY
                })
            }
            else {
                setSize({
                    width: window.innerHeight/1.2,
                    height: (window.innerHeight/1.2)/1.4142
            });
            setBgSize({
                width: stageRef?.current?.attrs?.width / scaleY,
                height: stageRef?.current?.attrs?.height / scaleX
            })
        }
    }

        window.addEventListener("resize", checkSize)
        return () => window.removeEventListener("resize", checkSize)
    }, [])

    useEffect(() => {
        const checkSize = () => {
            if(orientation === "landscape") {
                setSize({
                    width: window.innerWidth/2,
                    height: (window.innerWidth/2)/1.4142
                })    
                setBgSize({
                    width: stageRef?.current?.attrs?.width / scaleX,
                    height: stageRef?.current?.attrs?.height / scaleY
                })
            }
            else {
                setSize({
                    width: window.innerHeight/1.3,
                    height: (window.innerHeight/1.3)/1.4142
                });
                setBgSize({
                width: stageRef?.current?.attrs?.width / scaleY,
                height: stageRef?.current?.attrs?.height / scaleX
            })
            }
        }

        if(orientation === "landscape") {
            setSize({
                width: window.innerWidth/2,
                height: (window.innerWidth/2)/1.4142
            })    
        }
        else {
            setSize({
                width: window.innerHeight/1.3,
                height: (window.innerHeight/1.3)/1.4142
        });
    }

        window.addEventListener("resize", checkSize)
        return () => window.removeEventListener("resize", checkSize)
    }, [orientation])


    for(let i=0; i<objectState?.length; i++) {
        if(objectState[i]?.type === "Image" || objectState[i]?.type === "QrCode") {
            objects.push(
                <EditableImage
                    key={ objectState[i].index}
                    index={ objectState[i].index }
                    image={ objectState[i].image }
                    onSelect={ (e) => onImageSelect(e, objectState[i].index) }
                    isSelected={ objectState[i].index == selectedImageKey }
                    onImageChange={onImageChange}
                    width={objectState[i].width}
                    height={objectState[i].height}
                    rotation={objectState[i].rotation}
                    x={objectState[i].x}
                    y={objectState[i].y}
                    draggable
                />);
        } else if(objectState[i]?.type === "CertNo" || objectState[i]?.type === "TextBox") {
            objects.push(
                <EditableText 
                    key={objectState[i].index} 
                    index={objectState[i].index}
                    text={objectState[i].text}
                    fontFamily={objectState[i].fontFamily}
                    fontSize={objectState[i].fontSize}
                    fontStyle={objectState[i].fontStyle}
                    textDecoration={objectState[i].textDecoration}
                    textColor={objectState[i].textColor}
                    isSelected={ objectState[i].index == currentTextKey }
                    onSelect={ (e) => onTextBoxSelect(e.target, objectState[i].index) }
                    onTextBoxChange={onTextBoxChange}
                    rotation={objectState[i].rotation}
                    x={objectState[i].x}
                    y={objectState[i].y}
                    addTextArea={addTextArea}
                    width={objectState[i].width}
                    textAlignment={objectState[i].textAlignment}
                />
            );
        }
    }

    console.log(size);
    console.log(stageRef?.current?.attrs?.width, stageRef?.current?.attrs?.height)

    return (
        <section id="canvas" ref={containerRef} className="d-flex flex-column justify-content-center align-items-center py-3 bg-white">
            <div id="stage-container" ref={bgImageRef}>
                <Stage 
                    id="stage"
                    width={ orientation === "landscape" ? size.width : size.height }
                    height={ orientation === "landscape" ? size.height : size.width }
                    scaleX={ scaleX }
                    scaleY={ scaleY }
                    onMouseDown={checkDeselect}
                    ref={stageRef}
                    >
                    <Layer>
                        <Image 
                            id="bg-image"
                            image={ bgImageObject }
                            width={ orientation === "landscape" ? size.width/scaleX : size.height/scaleX }
                            height={ orientation === "landscape" ? size.height/scaleY : size.width/scaleY }
                            x={0}
                            y={0}
                        />
                        { objects.map(element => element )}
                    </Layer>
                </Stage>
            </div>
            {/* <div id="screenshot-div">
            </div>
            <canvas id="copy-canvas" className="border" width={ orientation === "landscape" ? size.width : size.height }
                    height={ orientation === "landscape" ? size.height : size.width }>
            </canvas> */}
            <textarea
                style={{ position: "absolute", display: textAreaVisibility, zIndex: 100,
                        // width: textAreaStyle.width*1.4+"px",
                        // height: textAreaStyle.height*1.7+"px",
                        width:  (textAreaStyle.width+60)+"px",
                        height: (textAreaStyle.height+30)+"px",
                        // fontSize: fontSize*1.2+"px",
                        fontSize: fontSize + "px",
                        fontFamily: fontFamily,
                        resize: "none",
                        color: textAreaStyle.textColor,
                        // transform: "rotate("+ textBoxRotation +"deg)",
                        transformOrigin: "top left",
                        lineHeight: textAreaStyle.lineHeight,
                        border: "2px solid teal",
                        overflow: 'hidden',
                        padding: "none",
                        margin: "none",
                        outline: "none",
                        left: ( parseInt(textAreaStyle.x) + (bgImageRef.current != undefined ? parseInt(bgImageRef.current.offsetLeft) : 0))+"px", 
                        top: ( parseInt(textAreaStyle.y) + ((bgImageRef.current != undefined ? parseInt(bgImageRef.current.offsetTop) : 0)))+"px",
                         }}
                value={currentTextBoxText}
                onChange={(e) => {
                        setCurrentTextBoxText(e.target.value);
                        // console.log(e.target.value.length * Number(e.target.style.fontSize.slice(0, -2)))
                        // console.log(e.target.style)
                        // e.target.style.width = e.target.value.length/2 * Number(e.target.style.fontSize.slice(0, -2)) + "px"; 
                        // e.target.style.height = e.target.style.height * Number(e.target.style.fontSize.slice(0, -2)) + "px";
                }}
                onKeyDown={(e) => {
                    if(e.key === 'Enter' && !e.shiftKey) {
                        setTextAreaVisibility("none");
                    }
                }}
            />
            
        </section>
    )
}

export default Canvas;